module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-5.1a523f72.jpg";